import { createTheme } from '@mui/material';
import type {
  Theme as AugmentedTheme,
  ThemeOptions as AugmentedThemeOptions,
} from '@mui/material/styles';

import { type } from '@packages/themes/tokens';
import { aspectRatio } from './values/aspectRatio';
import { brandColors } from './values/brandColors';
import { brandType } from './values/brandType';
import { breakpoints } from './values/breakpoints';
import { components } from './values/components';
import { fontWeights } from './values/fontWeights';
import { palette } from './values/palette';
import { spacing } from './values/spacing';
import { typography } from './values/typography';
import { zLevels } from './values/zLevels';

export const themeOptions: AugmentedThemeOptions = {
  palette,
  typography,
  components,
  fontWeights,
  brandColors,
  brandType,
  breakpoints,
  type,
  spacing,
  zLevels,
  aspectRatio,
};

export const v3 = createTheme(themeOptions);
export type V3Theme = AugmentedTheme;
